import posthog from 'posthog-js';

let postHogInitialized = false;

function getConfiguredPostHogValue(value: string | undefined) {
  const normalizedValue = value?.trim();
  if (!normalizedValue || normalizedValue.toLowerCase() === 'unknown') {
    return undefined;
  }
  return normalizedValue;
}

export function isPostHogConfigured() {
  return (
    typeof window !== 'undefined' &&
    import.meta.env.PROD &&
    Boolean(getConfiguredPostHogValue(import.meta.env.VITE_PUBLIC_POSTHOG_KEY))
  );
}

export function getPostHogClient() {
  return isPostHogConfigured() && postHogInitialized ? posthog : null;
}

export function initializePostHog() {
  const posthogKey = getConfiguredPostHogValue(import.meta.env.VITE_PUBLIC_POSTHOG_KEY);

  if (postHogInitialized || !isPostHogConfigured() || !posthogKey) {
    return;
  }

  const posthogHost = getConfiguredPostHogValue(import.meta.env.VITE_PUBLIC_POSTHOG_HOST);

  posthog.init(posthogKey, {
    ...(posthogHost ? { api_host: posthogHost, ui_host: posthogHost } : {}),
    capture_pageview: false,
    // API bodies carry invite links and provider credentials. Session recording can be switched
    // on in the PostHog project settings, and these client settings win over the project's.
    session_recording: { recordBody: false, recordHeaders: false },
  });
  postHogInitialized = true;
}
